<template>
  <div id="Resident-edit">

    <IForm :label-width="80" ref="formInline" :model="edit" :elem="residentElem" :rules="residentRule"  @on-submit="toSubmit" :submit="false" :showMessage="true">
      <Row>
        <Col :span="24">
          <FormItem label="头像">
            <el-upload class="avatar-uploader" action="#" :limit="1" :file-list="fileList" list-type="picture-card" :auto-upload="false"
                       :class="{ hideUpload: hideUpload }" :on-change="handleChange"
                       :on-preview="handlePreview" :on-remove="handleRemove" :before-upload="beforeAvatarUpload">
              <i class="el-icon-plus avatar-uploader-icon"/>
              <div slot="tip" class="el-upload__tip">只能上传png/jpg/jpeg文件，且大小不超过2MB</div>
            </el-upload>
            <Modal v-model="dialogVisible" width="50%" title="预览" :styles="{'top':'60px'}" :footerHide="true">
              <img style="display: block; max-width: 100%; margin: 0px auto;" :src="edit.face">
            </Modal>

          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col :span="12"><FormItem label="姓名" prop="name"><Input v-model="edit.name" type="text" placeholder="请输入学生姓名" maxlength="50"/></FormItem></Col>
        <Col :span="12">
          <FormItem label="性别" prop="gender">
            <Select v-model="edit.gender">
              <Option v-for="item in enums.genderList" :value="item.code" v-bind:key="item.code">{{ item.name }}</Option>
            </Select>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col :span="12">
          <FormItem :label-width="80" label="证件类型" prop="idCardType">
            <Select v-model="edit.idCardType" @on-change="changeIdCardType">
              <Option v-for="item in enums.idCardTypes" :value="item.value" v-bind:key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col :span="12">
          <FormItem :label-width="80" label="证件号码" prop="idCard" :required="edit.idCardType!==2">
            <Input v-model="edit.idCard" type="text" placeholder="请输入证件号码"
                   maxlength="20" :disabled="edit.idCardType === 2"/>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col :span="12">
          <FormItem :label-width="80" label="出生日期" prop="birthday" :required="true">
            <DatePicker :value="edit.birthday" :editable="false" @on-change="changeBirthday"
                        type="date" format="yyyy-MM-dd" placeholder="出生日期" style="width: 100%;"/>
          </FormItem>
        </Col>
        <Col :span="12">
          <FormItem :label-width="80" label="手机号码" prop="phone">
            <Input v-model="edit.phone" type="number" placeholder="请输入手机号码" maxlength="11"/>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col :span="12">
          <FormItem :label-width="80" label="固定电话" prop="phone">
            <Input v-model="edit.telPhone" type="text" placeholder="请输入固定电话" maxlength="15"/>
          </FormItem>
        </Col>
        <Col :span="12">
          <FormItem label="民族" prop="nationsId">
            <Select v-model="edit.nationsId">
              <Option v-for="item in nationsList" :value="item.value" v-bind:key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col :span="12"><FormItem :label-width="120" label="现住址" prop="currentAddress"><Input v-model="edit.currentAddress" type="text" placeholder="请输入现住址"/></FormItem></Col>
        <Col :span="12"><FormItem :label-width="120" label="户籍地" prop="address"><Input v-model="edit.address" type="text" placeholder="请输入户籍地"/></FormItem></Col>
      </Row>
      <Row>
        <Col :span="12">
          <FormItem :label-width="120" label="状态" prop="status">
            <Select v-model="edit.status">
              <Option v-for="item in enums.status" :value="item.value" v-bind:key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col>
          <button type="button" class="ivu-btn ivu-btn-primary" @click="addFamilyMembers(1)"><i class="el-icon-plus" />新增亲属</button>
        </Col>
      </Row>
      <Row v-if=" familyMembers && familyMembers.length > 0">
        <Col span="23">
          <vxe-table border class="mytable-scrollbar" ref="familyMember"
            :row-config="{isCurrent: true, isHover: true}" :custom-config="{storage: true,visible:true}" :data="familyMembers"
            :sort-config="{trigger: 'cell'}" style="margin-top: 10px;">
            <vxe-column  v-for="item in columns" :field="item.key" :title="item.title" :visible="item.visible"
                         :formatter="item.formatter?item.formatter:''" :fixed="item.fixed ? item.fixed : ''" :width="item.width">
              <template #default="{ row }">
                <Select v-model="row[item.key]" v-if="item.key == 'type'" placement="top" style="z-index: 9999;" transfer>
                  <Option v-for="item in enums.familyMemberTypeList" :value="item.code" v-bind:key="item.code"
                          style="z-index: 9999;">{{ item.value }}</Option>
                </Select>
                <Select v-model="row[item.key]" v-else-if="item.key.indexOf('idcardType') !== -1" placement="top" transfer>
                  <Option v-for="item in enums.idCardTypes" :value="item.value" v-bind:key="item.value"  >{{ item.label }}</Option>
                </Select>
                <el-input v-model="row[item.key]" placeholder="请输入身份证" maxlength="18" size="mini" v-else-if="item.key == 'idcard'" @input="idcardInput(row)"/>
                <Select v-model="row[item.key]" v-else-if="item.key.indexOf('gender') !== -1" placement="top" transfer>
                  <Option v-for="item in enums.genderList" :value="item.code" v-bind:key="item.code"  >{{ item.name }}</Option>
                </Select>
                <Select v-model="row[item.key]" v-else-if="item.key.indexOf('occupationId') !== -1" placement="top" transfer>
                  <Option v-for="item in enums.occupationsList" :value="item.code" v-bind:key="item.code"  >{{ item.value }}</Option>
                </Select>
                <DatePicker :value="row[item.key]" :editable="false" v-else-if="item.key.indexOf('birthday') !== -1"
                            @on-change="(val)=>{row.birthday=val}"
                            type="date" format="yyyy-MM-dd" placeholder="出生日期" placement="top" transfer/>
                <el-input v-model="row[item.key]" placeholder="请输入" maxlength="125" size="mini" v-else/>
              </template>
            </vxe-column>

            <vxe-column title="操作" width="180" show-overflow fixed="right">
              <template #default="{ row }">
                <el-button size="small" type="text" @click="addFamilyMembers(-1,row.rowId)">删除</el-button>
                <span v-if="row.status == 2">默认家属</span>
                <el-button size="small" type="text" @click="setDefault(row.rowId)"  v-if="row.status == 1">设为默认家属</el-button>
              </template>
            </vxe-column>
          </vxe-table>
        </Col>
      </Row>

    </IForm>

  </div>
</template>
<script>
import {_get, _save} from "@/services/resident/resident";
import {mixins} from "@/mixins";
import {enums} from "@/services/enums";
export default {
  name: "ResidentEdit",
  mixins: [mixins],
  data() {
    return {
      edit:{
        id:"",
        name:"",
        gender:"",
        idCardType:"",
        idCard:"",
        birthday:"",
        age:"",
        phone:"",
        telPhone:"",
        nationsId:"",
        currentAddress:"",
        address:"",
        face:"",
        status:1,
        remark:"",
        familyMembers:[]
      },
      init:"",
      enums:Object.assign({},enums),
      fileList: [],
      hideUpload: false,
      dialogImageUrl: '',
      dialogVisible: false,
      columns : [
        {
          title: "姓名",
          key: "name",
          visible: true,
          width:120
        },
        {
          title: "亲属关系",
          key: "type",
          visible: true,
          width:120
        },
        {
          title: "证件类型",
          key: "idcardType",
          visible: true,
          width:200
        },
        {
          title: "证件号码",
          key: "idcard",
          visible: true,
          width:200
        },
        {
          title: "性别",
          key: "gender",
          visible: true,
          width:80
        },
        {
          title: "出生日期",
          key: "birthday",
          visible: true,
          width:200
        },
        {
          title: "职业",
          key: "occupationId",
          visible: true,
          width:200
        },
        {
          title: "手机号码",
          key: "phone",
          visible: true,
          width:200
        },
        {
          title: "固定电话",
          key: "telPhone",
          visible: true,
          width:200
        },
      ],
      residentElem:[],
      residentRule: {
        name: [
          {required: true, message: '姓名不能为空', trigger: 'blur'},
          {maxlength:50,message:"姓名长度不能超过50个字",trigger: 'blur'}
        ],
        gender: [
          {required: true, message: "请选择性别", type:'number'}
        ],
        idCardType: [
          {required: true, message: "请选择证件类型", type:'number'}
        ],
        idCard: [
          {validator:function(rule, value, callback){
              if ((!this.edit.idCardType || this.edit.idCardType !== 2) && (!value || value.length === 0)) {
                callback(new Error('证件号码不能为空'));
              } else {
                callback();
              }
            }.bind(this), trigger: 'input' }
        ],
        birthday: [
          {validator:function(rule, value, callback){
              if (!this.edit.birthday || this.edit.birthday.length === 0) {
                callback(new Error('请选择出生日期'));
              } else if (!this.isValidDateBasic(this.edit.birthday)) {
                callback(new Error('请输入正确的出生日期'));
              } else {
                callback();
              }
            }.bind(this), trigger: 'input' }
        ],
      },
    };
  },
  watch:{
    'edit.idCard': {
      handler(newVal){
        if(newVal && newVal.length === 18){
          this.edit.birthday = newVal.substring(6, 10) + "-" + newVal.substring(10, 12) + "-" + newVal.substring(12, 14);
          let sex = newVal.substring(16, 17);
          this.edit.gender = parseInt(sex) % 2 === 0 ? 2 : 1;
        }
      }
    },
  },
  computed:{
    familyMembers(){
      if (this.edit.familyMembers){
        let tempList = Object.assign([],this.edit.familyMembers)
        tempList.forEach(it=>{ it.rowId = Math.random()})
        this.edit.familyMembers = tempList;
        return this.edit.familyMembers;
      }else{
        this.edit.familyMembers=[];
        return this.edit.familyMembers;
      }
    }
  },
  mounted() {
    this.applyNationsList();
    this.init = Object.assign({}, this.edit)
  },
  methods: {
    isValidDateBasic(dateString) {
      const date = new Date(dateString);
      // 检查 date 是否是 Date 的实例，并且其时间戳不是 NaN
      return date instanceof Date && !isNaN(date.getTime());
    },
    idcardInput(row){
      if(row.idcard && row.idcard.length == 18) {
        let yearBirth = row.idcard.substring(6, 10);
        let monthBirth = row.idcard.substring(10, 12);
        let dayBirth = row.idcard.substring(12, 14);
        let _birthday = yearBirth + "-" + monthBirth + "-" + dayBirth;
        let _gender = (row.idcard.substring(16, 17) % 2 == 0) ? 2 : 1;

        for (let index = 0; index < this.edit.familyMembers.length; index++) {
          let temp = this.edit.familyMembers[index];
          let birthday = temp.birthday;
          let gender = temp.gender;
          if (temp.rowId === row.rowId){
            birthday = _birthday;
            gender = _gender;
          }
          this.$set(this.edit.familyMembers, index,
              {
                id: temp.id,
                rowId: temp.rowId,
                name: temp.name,
                type: temp.type,
                idcardType: temp.idcardType,
                idcard: temp.idcard,
                gender: gender,
                birthday: birthday,
                phone: temp.phone,
                telPhone: temp.telPhone,
                occupationId: temp.occupationId,
                status: temp.status
              }
          )
        }
      }
    },
    addFamilyMembers(type, id){
      if (type > 0){
        let status = this.edit.familyMembers.length == 0 ? 2 : 1;
        this.edit.familyMembers.push({ rowId: Math.random(), name:"",type:"",idcardType:"",idcard:"",gender:"",birthday:"",phone:"",telPhone:"",occupationId:"",status: status});
      }else{
        for (let index = 0; index < this.edit.familyMembers.length; index++) {
          let temp = this.edit.familyMembers[index]
          if (temp.rowId === id){
            this.edit.familyMembers.splice(index,1);
          }
        }
      }
    },
    setDefault(id) {
      for (let index = 0; index < this.edit.familyMembers.length; index++) {
        let temp = this.edit.familyMembers[index]
        let status = 1;
        if (temp.rowId === id) {
          status = 2;
        }
        this.$set(this.edit.familyMembers, index,
            {
              id: temp.id,
              rowId: temp.rowId,
              name: temp.name,
              type: temp.type,
              idcardType: temp.idcardType,
              idcard: temp.idcard,
              gender: temp.gender,
              birthday: temp.birthday,
              phone: temp.phone,
              telPhone: temp.telPhone,
              occupationId: temp.occupationId,
              status: status
            }
        )
      }
    },
    changeIdCardType(val){
      if(val && val === 2){
        this.edit.idCard = "";
      }
    },
    changeBirthday(val){
      this.edit.birthday = val;
    },
    handleModal(row) {
      this.$refs["formInline"].handleReset();

      this.fileList = [];
      if (!row) {
        this.handleCreate();
      } else {
        this.handleEdit(row);
      }
      this.$forceUpdate();
    },
    handleCreate() {
      this.edit = Object.assign({}, this.init);
    },
    handleEdit(row) {
      const params = {id: row.id};
      _get(params).then(res =>{
          if (res.errcode === 1) {
            res.data.birthday = res.data.birthday && res.data.birthday.length != 10 ? "" : res.data.birthday;
            this.edit = Object.assign({}, res.data);

            if(this.edit.face){
              this.fileList = [{name: this.edit.faceFileName, url: this.edit.face}];
            }
            this.$forceUpdate();
          }
      })
    },
    handleSubmit() {
      this.$refs["formInline"].handleSubmit('form');
    },
    toSubmit() {
      if(this.fileList && this.fileList.length > 0 && this.fileList[0].raw){
        this.edit.file = this.fileList[0].raw;
      }
      _save(this.edit).then(res => {
          if (res.errcode === 1) {
            this.$message.success("保存成功");
            this.$emit("on-submit", false);
          }else{
            this.$message.error(res.errmsg);
          }
        }).catch(() => {});
    },
    handleChange(file, fileList){
      this.fileList = fileList;
      this.dialogImageUrl = file.url;
      this.hideUpload = fileList.length >= 1;
    },
    handlePreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
      this.dialogImageUrl = "";
      this.edit.face = "";
      this.hideUpload = fileList.length >= 1;
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || 'image/png' || 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 PNG/JPG/JPEG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    }
  }
};
</script>
<style lang="postcss" scoped>
/* 隐藏上传按钮 */
.hideUpload /deep/ .el-upload--picture-card {
  display: none !important;
}
</style>
